exports.init = function CurrencySelector() {
  const $aprovadoresOptions = $('#aprovadoresOptions');
  const $selector = $('#idAprovadores');

  if ($selector.length) {
    $selector.selectize({
      options: JSON.parse($aprovadoresOptions.val()),
      create: false,
      selectOnTab: true,
      maxItems: null,
      hideSelected: true,
      searchField: ['id', 'nome'],
      labelField: 'nome',
      valueField: 'id'
    });
  }
}
